/* eslint-disable no-restricted-syntax */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-trailing-spaces */
/* eslint-disable padded-blocks */
/* eslint-disable indent */

export const initAssessmentsPage = () => {

    //  Check if there is a show-filters button
    //  Add event listener to open mobile filter panel
    if (document.getElementById('show-filters')) {
        const elShow = document.getElementById('show-filters');
        elShow.addEventListener('click', (e) => {
            e.preventDefault();
            document.getElementById('filter-panel').classList.add('active');
          });
    }

    //  Check if there is a hide-filters button
    //  Add event listener to close mobile filter panel
    if (document.getElementById('hide-filters')) {
        const elHide = document.getElementById('hide-filters');
        elHide.addEventListener('click', (e) => {
            e.preventDefault();
            document.getElementById('filter-panel').classList.remove('active');
          });
    }

    //  If there is an apply filters button
    //  When on desktop, it will be hidden and we want it to trigger when a checkbox is selected
    if (document.querySelectorAll('.assessments-page__filter-container .form-item input')) {
        const form_items = document.querySelectorAll('.assessments-page__filter-container .form-item input');
        for (const form_item of form_items) {
            form_item.addEventListener('change', () => {
                //  Use the .active class to make sure we don't apply this in mobile
                if (!document.querySelector('.assessments-page__filter-container').classList.contains('active')) {
                    document.querySelector('.assessments-page [data-drupal-selector="edit-submit-assessments"]').click();
                }
            });
        }
    }
};  
export default 'initExpandableSection';
